import React, { useEffect, useMemo, useState } from "react";

import {
  FaArrowLeft,
  FaChevronDown,
  FaExchangeAlt,
} from "react-icons/fa";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import "./DepositExpress.css";

import CountrySelector from "./CountrySelector";


// =====================================================
// PAYMENT METHODS KWA KILA NCHI
// =====================================================

const countryNetworks = {

  Kenya: [
    "Safaricom",
    "Airtel",
  ],

  Uganda: [
    "Airtel",
    "MTN",
  ],

  Rwanda: [
    "Airtel",
    "MTN",
  ],

  Burundi: [
    "Ecocash",
    "Lumicash",
  ],

  "DR Congo": [
    "Vodacom M-Pesa",
    "Airtel",
    "Orange",
    "Illico Cash",
  ],

  "DRC - Congo": [
    "Vodacom M-Pesa",
    "Airtel",
    "Orange",
    "Illico Cash",
  ],

  Zambia: [
    "Airtel",
    "MTN",
    "Zamtel",
  ],

  Malawi: [
    "Airtel",
    "TNM",
  ],

  Mozambique: [
    "Vodacom",
  ],

  Zimbabwe: [
    "EcoCash",
  ],

  "South Sudan": [
    "MGurush",
    "MTN",
  ],

  Botswana: [
    "Orange",
    "BTC",
    "Mascom",
  ],

  Madagascar: [
    "Airtel",
    "Orange",
  ],

};


// =====================================================
// MINIMUM DEPOSIT KWA KILA NCHI
// =====================================================

const countryMinAmounts = {

  Kenya: 927.64,

  Uganda: 25974.02,

  Rwanda: 10526.36,

  Burundi: 21276.6,

  "DR Congo": 7.24,

  "DRC - Congo": 7.24,

  Zambia: 135.84,

  Malawi: 14468.8,

  Mozambique: 457.56,

  Zimbabwe: 7.24,

  "South Sudan": 42553.2,

  Botswana: 94.36,

  Madagascar: 29198,

};


// =====================================================
// DEFAULT COUNTRY
// =====================================================

const defaultCountry = {

  name: "Kenya",

  flag: "🇰🇪",

  currency: "KES",

  rate: 129.50,

};


const languageCodes = ["en", "fr", "sw", "pt", "es", "ar", "zh", "hi", "bn", "ru", "de", "it", "nl", "tr", "ja", "ko", "vi", "th", "id", "ms", "ur", "fa", "ha", "yo", "zu", "am", "so", "rw", "lg", "af"];

const translations = {
  back: ["Go back", "Retour", "Rudi nyuma", "Voltar", "Volver", "رجوع", "返回", "वापस जाएँ", "ফিরে যান", "Назад", "Zurück", "Indietro", "Terug", "Geri dön", "戻る", "뒤로", "Quay lại", "ย้อนกลับ", "Kembali", "Kembali", "واپس جائیں", "بازگشت", "Komawa", "Pada sẹhin", "Buyela emuva", "ተመለስ", "Dib u noqo", "Subira inyuma", "Ddayo emabega", "Gaan terug"],
  depositExpress: ["Deposit Express", "Dépôt express", "Amana ya haraka", "Depósito expresso", "Depósito exprés", "إيداع سريع", "快速存款", "त्वरित जमा", "দ্রুত জমা", "Экспресс-депозит", "Express-Einzahlung", "Deposito express", "Express storten", "Hızlı para yatırma", "クイック入金", "빠른 입금", "Nạp tiền nhanh", "ฝากเงินด่วน", "Deposit cepat", "Deposit ekspres", "فوری ڈپازٹ", "واریز سریع", "Ajiya cikin sauri", "Idogo kiakia", "Idiphozithi esheshayo", "በፍጥነት ማስገባት", "Dhigasho degdeg ah", "Kubitsa byihuse", "Okuteeka ssente mu bwangu", "Vinnige deposito"],
  deposit: ["Deposit", "Dépôt", "Amana", "Depósito", "Depósito", "إيداع", "存款", "जमा करें", "জমা", "Депозит", "Einzahlen", "Deposito", "Storten", "Para yatır", "入金", "입금", "Nạp tiền", "ฝากเงิน", "Deposit", "Deposit", "ڈپازٹ", "واریز", "Ajiya", "Idogo", "Idiphozithi", "ማስገባት", "Dhigasho", "Kubitsa", "Teeka ssente", "Deposito"],
  withdraw: ["Withdraw", "Retirer", "Toa pesa", "Sacar", "Retirar", "سحب", "提现", "निकासी", "উত্তোলন", "Вывести", "Auszahlen", "Preleva", "Opnemen", "Para çek", "出金", "출금", "Rút tiền", "ถอนเงิน", "Tarik", "Keluarkan", "رقم نکلوانا", "برداشت", "Cire kuɗi", "Yọ owo", "Khipha imali", "ማውጣት", "La bax", "Kubikuza", "Ssaamu ssente", "Onttrek"],
  youPay: ["You Pay", "Vous payez", "Unalipa", "Você paga", "Tú pagas", "أنت تدفع", "您支付", "आप भुगतान करते हैं", "আপনি দেবেন", "Вы платите", "Sie zahlen", "Paghi", "U betaalt", "Ödediğiniz", "支払額", "지불 금액", "Bạn trả", "คุณจ่าย", "Anda bayar", "Anda bayar", "آپ ادا کرتے ہیں", "شما پرداخت می‌کنید", "Za ka biya", "O sanwo", "Uyakhokha", "እርስዎ ይከፍላሉ", "Waad bixinaysaa", "Urishyura", "Osasula", "Jy betaal"],
  minimumDeposit: ["Minimum deposit:", "Dépôt minimum :", "Kiasi cha chini cha kuweka:", "Depósito mínimo:", "Depósito mínimo:", "الحد الأدنى للإيداع:", "最低存款：", "न्यूनतम जमा:", "সর্বনিম্ন জমা:", "Минимальный депозит:", "Mindesteinzahlung:", "Deposito minimo:", "Minimale storting:", "Minimum yatırma:", "最低入金額：", "최소 입금액:", "Nạp tối thiểu:", "ฝากขั้นต่ำ:", "Deposit minimum:", "Deposit minimum:", "کم از کم ڈپازٹ:", "حداقل واریز:", "Mafi ƙarancin ajiya:", "Idogo to kere julo:", "Idiphozithi encane:", "ዝቅተኛ ተቀማጭ:", "Dhigashada ugu yar:", "Amafaranga make yo kubitsa:", "Omuwendo omutono ogw’okuteeka:", "Minimum deposito:"],
  minimumAmount: ["Minimum amount is", "Le montant minimum est", "Kiasi cha chini ni", "O valor mínimo é", "El importe mínimo es", "الحد الأدنى للمبلغ هو", "最低金额为", "न्यूनतम राशि है", "সর্বনিম্ন পরিমাণ হলো", "Минимальная сумма —", "Der Mindestbetrag ist", "L'importo minimo è", "Het minimumbedrag is", "Minimum tutar", "最低金额为", "최소 금액은", "Số tiền tối thiểu là", "จำนวนเงินขั้นต่ำคือ", "Jumlah minimum adalah", "Jumlah minimum ialah", "کم از کم رقم ہے", "حداقل مبلغ", "Mafi ƙarancin adadin shi ne", "Iye to kere julo ni", "Inani elincane ngu", "ዝቅተኛው መጠን", "Qadarka ugu yar waa", "Amafaranga make ni", "Omuwendo omutono gwe", "Minimum bedrag is"],
  youReceive: ["You Receive", "Vous recevez", "Unapokea", "Você recebe", "Recibes", "أنت تستلم", "您收到", "आपको मिलेगा", "আপনি পাবেন", "Вы получаете", "Sie erhalten", "Ricevi", "U ontvangt", "Alacağınız", "受取額", "받는 금액", "Bạn nhận", "คุณได้รับ", "Anda terima", "Anda terima", "آپ کو ملے گا", "دریافت می‌کنید", "Za ka karɓa", "O gba", "Uyathola", "ይቀበላሉ", "Waad helaysaa", "Uzakira", "Ofuna", "Jy ontvang"],
  exchangeRate: ["Exchange Rate", "Taux de change", "Kiwango cha ubadilishaji", "Taxa de câmbio", "Tipo de cambio", "سعر الصرف", "汇率", "विनिमय दर", "বিনিময় হার", "Обменный курс", "Wechselkurs", "Tasso di cambio", "Wisselkoers", "Döviz kuru", "為替レート", "환율", "Tỷ giá", "อัตราแลกเปลี่ยน", "Nilai tukar", "Kadar pertukaran", "شرح تبادلہ", "نرخ ارز", "Canjin kuɗi", "Oṣuwọn paṣipaarọ", "Izinga lokushintshisana", "የምንዛሬ ተመን", "Sarifka lacagaha", "Igipimo cy’ivunjisha", "Omuwendo gw’okukyusa", "Wisselkoers"],
  excludeVerification: ["Exclude ads that require verification", "Exclure les annonces nécessitant une vérification", "Usionyeshe matangazo yanayohitaji uthibitishaji", "Excluir anúncios que exigem verificação", "Excluir anuncios que requieren verificación", "استبعاد الإعلانات التي تتطلب التحقق", "排除需要验证的广告", "सत्यापन की आवश्यकता वाले विज्ञापन हटाएँ", "যাচাইকরণ প্রয়োজন এমন বিজ্ঞাপন বাদ দিন", "Исключить объявления, требующие проверки", "Anzeigen ausschließen, die eine Verifizierung erfordern", "Escludi annunci che richiedono verifica", "Advertenties uitsluiten die verificatie vereisen", "Doğrulama gerektiren reklamları hariç tut", "認証が必要な広告を除外", "인증이 필요한 광고 제외", "Loại trừ quảng cáo cần xác minh", "ยกเว้นโฆษณาที่ต้องยืนยันตัวตน", "Kecualikan iklan yang memerlukan verifikasi", "Kecualikan iklan yang memerlukan pengesahan", "تصدیق درکار اشتہارات خارج کریں", "حذف تبلیغاتی که نیاز به تأیید دارند", "Cire tallace-tallacen da ke buƙatar tantancewa", "Yọ ipolówó tó nílò ìjẹ́rìí kúrò", "Khipha izikhangiso ezidinga ukuqinisekiswa", "ማረጋገጫ የሚፈልጉ ማስታወቂያዎችን አስወግድ", "Ka reeb xayeysiisyada u baahan xaqiijin", "Kuramo amatangazo asaba kwemeza", "Ggyako ebiwandiiko ebyetaaga okukakasa", "Sluit advertensies uit wat verifikasie vereis"],
  paymentMethod: ["Payment Method", "Mode de paiement", "Njia ya malipo", "Método de pagamento", "Método de pago", "طريقة الدفع", "支付方式", "भुगतान का तरीका", "পেমেন্ট পদ্ধতি", "Способ оплаты", "Zahlungsmethode", "Metodo di pagamento", "Betaalmethode", "Ödeme yöntemi", "支払い方法", "결제 방법", "Phương thức thanh toán", "วิธีชำระเงิน", "Metode pembayaran", "Kaedah pembayaran", "ادائیگی کا طریقہ", "روش پرداخت", "Hanyar biyan kuɗi", "Ọ̀nà ìsanwó", "Indlela yokukhokha", "የክፍያ ዘዴ", "Habka lacag bixinta", "Uburyo bwo kwishyura", "Engeri y’okusasulamu", "Betaalmetode"],
  selectPayment: ["Select payment method", "Sélectionner le mode de paiement", "Chagua njia ya malipo", "Selecione o método de pagamento", "Selecciona el método de pago", "اختر طريقة الدفع", "选择支付方式", "भुगतान का तरीका चुनें", "পেমেন্ট পদ্ধতি নির্বাচন করুন", "Выберите способ оплаты", "Zahlungsmethode auswählen", "Seleziona il metodo di pagamento", "Selecteer betaalmethode", "Ödeme yöntemi seçin", "支払い方法を選択", "결제 방법 선택", "Chọn phương thức thanh toán", "เลือกวิธีชำระเงิน", "Pilih metode pembayaran", "Pilih kaedah pembayaran", "ادائیگی کا طریقہ منتخب کریں", "روش پرداخت را انتخاب کنید", "Zaɓi hanyar biyan kuɗi", "Yan ọ̀nà ìsanwó", "Khetha indlela yokukhokha", "የክፍያ ዘዴ ይምረጡ", "Dooro habka lacag bixinta", "Hitamo uburyo bwo kwishyura", "Londa engeri y’okusasulamu", "Kies betaalmetode"],
  selectPaymentTitle: ["Select Payment Method", "Choisir le mode de paiement", "Chagua Njia ya Malipo", "Selecionar método de pagamento", "Seleccionar método de pago", "اختر طريقة الدفع", "选择支付方式", "भुगतान का तरीका चुनें", "পেমেন্ট পদ্ধতি নির্বাচন করুন", "Выберите способ оплаты", "Zahlungsmethode auswählen", "Seleziona metodo di pagamento", "Betaalmethode selecteren", "Ödeme Yöntemini Seç", "支払い方法を選択", "결제 방법 선택", "Chọn phương thức thanh toán", "เลือกวิธีชำระเงิน", "Pilih Metode Pembayaran", "Pilih Kaedah Pembayaran", "ادائیگی کا طریقہ منتخب کریں", "انتخاب روش پرداخت", "Zaɓi Hanyar Biyan Kuɗi", "Yan Ọ̀nà Ìsanwó", "Khetha Indlela Yokukhokha", "የክፍያ ዘዴ ይምረጡ", "Dooro Habka Lacag Bixinta", "Hitamo Uburyo bwo Kwishyura", "Londa Engeri y’Okusasulamu", "Kies betaalmetode"],
  noPayment: ["No payment methods available", "Aucun mode de paiement disponible", "Hakuna njia za malipo zinazopatikana", "Nenhum método de pagamento disponível", "No hay métodos de pago disponibles", "لا توجد طرق دفع متاحة", "没有可用的支付方式", "कोई भुगतान विधि उपलब्ध नहीं है", "কোনো পেমেন্ট পদ্ধতি উপলব্ধ নেই", "Нет доступных способов оплаты", "Keine Zahlungsmethoden verfügbar", "Nessun metodo di pagamento disponibile", "Geen betaalmethoden beschikbaar", "Kullanılabilir ödeme yöntemi yok", "利用可能な支払い方法がありません", "사용 가능한 결제 방법이 없습니다", "Không có phương thức thanh toán", "ไม่มีวิธีชำระเงิน", "Tidak ada metode pembayaran", "Tiada kaedah pembayaran tersedia", "ادائیگی کے طریقے دستیاب نہیں", "روش پرداختی موجود نیست", "Babu hanyoyin biyan kuɗi", "Kò sí ọ̀nà ìsanwó tó wà", "Azikho izindlela zokukhokha ezitholakalayo", "ምንም የክፍያ ዘዴ የለም", "Ma jiraan habab lacag bixin ah", "Nta buryo bwo kwishyura buhari", "Tewali ngeri ya kusasulamu eriwo", "Geen betaalmetodes beskikbaar nie"],
  for: ["for", "pour", "kwa", "para", "para", "لـ", "适用于", "के लिए", "এর জন্য", "для", "für", "per", "voor", "için", "対象：", "대상:", "cho", "สำหรับ", "untuk", "untuk", "کے لیے", "برای", "domin", "fún", "kuze kube", "ለ", "loogu talagalay", "kuri", "ku", "vir"],
  continue: ["Continue", "Continuer", "Endelea", "Continuar", "Continuar", "متابعة", "继续", "जारी रखें", "চালিয়ে যান", "Продолжить", "Weiter", "Continua", "Doorgaan", "Devam et", "続行", "계속", "Tiếp tục", "ดำเนินการต่อ", "Lanjutkan", "Teruskan", "جاری رکھیں", "ادامه", "Ci gaba", "Tẹ̀síwájú", "Qhubeka", "ቀጥል", "Sii wad", "Komeza", "Weyongerayo", "Gaan voort"],
  close: ["Close", "Fermer", "Funga", "Fechar", "Cerrar", "إغلاق", "关闭", "बंद करें", "বন্ধ করুন", "Закрыть", "Schließen", "Chiudi", "Sluiten", "Kapat", "閉じる", "닫기", "Đóng", "ปิด", "Tutup", "Tutup", "بند کریں", "بستن", "Rufe", "Paade", "Vala", "ዝጋ", "Xir", "Funga", "Ggalawo", "Maak toe"],
  amountRequired: ["Please enter an amount to continue.", "Veuillez saisir un montant pour continuer.", "Tafadhali weka kiasi ili kuendelea.", "Insira um valor para continuar.", "Introduce una cantidad para continuar.", "يرجى إدخال مبلغ للمتابعة.", "请输入金额以继续。", "जारी रखने के लिए राशि दर्ज करें।", "চালিয়ে যেতে একটি পরিমাণ লিখুন।", "Введите сумму, чтобы продолжить.", "Bitte geben Sie einen Betrag ein, um fortzufahren.", "Inserisci un importo per continuare.", "Voer een bedrag in om door te gaan.", "Devam etmek için bir tutar girin.", "続行するには金額を入力してください。", "계속하려면 금액을 입력하세요.", "Vui lòng nhập số tiền để tiếp tục.", "กรุณากรอกจำนวนเงินเพื่อดำเนินการต่อ", "Masukkan jumlah untuk melanjutkan.", "Sila masukkan jumlah untuk meneruskan.", "جاری رکھنے کے لیے رقم درج کریں۔", "برای ادامه مبلغی وارد کنید.", "Da fatan za a shigar da adadi don ci gaba.", "Jọ̀wọ́ tẹ iye owó sílẹ̀ láti tẹ̀síwájú.", "Faka inani ukuze uqhubeke.", "እባክዎ ለመቀጠል መጠን ያስገቡ።", "Fadlan geli lacag si aad u sii wadato.", "Shyiramo amafaranga kugira ngo ukomeze.", "Yingiza omuwendo okusobola okugenda mu maaso.", "Voer ’n bedrag in om voort te gaan."],
  networkRequired: ["Please select a payment network.", "Veuillez sélectionner un réseau de paiement.", "Tafadhali chagua mtandao wa malipo.", "Selecione uma rede de pagamento.", "Selecciona una red de pago.", "يرجى اختيار شبكة دفع.", "请选择支付网络。", "कृपया भुगतान नेटवर्क चुनें।", "একটি পেমেন্ট নেটওয়ার্ক নির্বাচন করুন।", "Выберите платежную сеть.", "Bitte wählen Sie ein Zahlungsnetzwerk aus.", "Seleziona una rete di pagamento.", "Selecteer een betalingsnetwerk.", "Lütfen bir ödeme ağı seçin.", "支払いネットワークを選択してください。", "결제 네트워크를 선택하세요.", "Vui lòng chọn mạng thanh toán.", "กรุณาเลือกเครือข่ายการชำระเงิน", "Pilih jaringan pembayaran.", "Sila pilih rangkaian pembayaran.", "براہ کرم ادائیگی کا نیٹ ورک منتخب کریں۔", "لطفاً یک شبکه پرداخت انتخاب کنید.", "Da fatan za a zaɓi hanyar biyan kuɗi.", "Jọ̀wọ́ yan nẹ́tíwọ́ọ̀kì ìsanwó.", "Sicela ukhethe inethiwekhi yokukhokha.", "እባክዎ የክፍያ ኔትወርክ ይምረጡ።", "Fadlan dooro shabakad lacag bixin.", "Hitamo urusobe rwo kwishyura.", "Londa omukutu gw’okusasulamu.", "Kies asseblief ’n betaalnetwerk."],
};

const getCurrentLanguage = () => {
  try {
    const saved = localStorage.getItem("language") || "en";
    return languageCodes.includes(saved) ? saved : "en";
  } catch {
    return "en";
  }
};

// =====================================================
// DEPOSIT EXPRESS
// =====================================================

export default function DepositExpress() {

  // ===================================================
  // ROUTER
  // ===================================================

  const location = useLocation();

  const navigate = useNavigate();

  // Lugha inayochaguliwa na mtumiaji
  const [language, setLanguage] = useState(getCurrentLanguage);

  useEffect(() => {
    const updateLanguage = () => setLanguage(getCurrentLanguage());

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const langIndex = languageCodes.indexOf(language);
  const t = Object.fromEntries(
    Object.entries(translations).map(([key, values]) => [
      key,
      values[langIndex] || values[0],
    ])
  );


  // ===================================================
  // COUNTRY KUTOKA COUNTRY SELECTOR
  // ===================================================

  const countryFromSelector =
    location.state?.country || null;


  // ===================================================
  // TAB
  // ===================================================

  const [tab, setTab] =
    useState("Buy");


  // ===================================================
  // AMOUNT
  // ===================================================

  const [amount, setAmount] =
    useState("");


  // ===================================================
  // COUNTRY POPUP
  // ===================================================

  const [showCountry, setShowCountry] =
    useState(false);


  // ===================================================
  // PAYMENT METHOD POPUP
  // ===================================================

  const [showPaymentMethods, setShowPaymentMethods] =
    useState(false);


  // ===================================================
  // SELECTED PAYMENT METHOD
  // ===================================================

  const [selectedMethod, setSelectedMethod] =
    useState("");


  // ===================================================
  // VERIFICATION
  // ===================================================

  const [excludeVerification, setExcludeVerification] =
    useState(false);


  // ===================================================
  // VALIDATION MESSAGE
  // ===================================================

  const [validationMessage, setValidationMessage] =
    useState("");


  // ===================================================
  // SELECTED COUNTRY
  // ===================================================

  const [selectedCountry, setSelectedCountry] =
    useState(
      countryFromSelector ||
      defaultCountry
    );


  // ===================================================
  // COUNTRY SELECT
  // ===================================================

  const handleCountrySelect = (country) => {

    // Weka nchi mpya
    setSelectedCountry(country);


    // Futa amount ya nchi iliyopita
    setAmount("");


    // Futa payment method ya nchi iliyopita
    setSelectedMethod("");


    // Futa validation
    setValidationMessage("");


    // Funga popup
    setShowCountry(false);


    // Update router state
    navigate(
      "/deposit-express",
      {
        replace: true,

        state: {
          country: country,
        },
      }
    );

  };


  // ===================================================
  // PAYMENT METHOD SELECT
  // ===================================================

  const handlePaymentMethod = (network) => {

    setSelectedMethod(network);

    // Ondoa ujumbe wa error
    setValidationMessage("");

    // Funga popup
    setShowPaymentMethods(false);

  };


  // ===================================================
  // AVAILABLE NETWORKS
  // ===================================================

  const availableNetworks =
    countryNetworks[
      selectedCountry.name
    ] || [];


  // ===================================================
  // NUMERIC AMOUNT
  // ===================================================

  const numericAmount =
    Number(amount) || 0;


  // ===================================================
  // MINIMUM AMOUNT
  // ===================================================

  const minimumAmount =
    Number(
      countryMinAmounts[
        selectedCountry.name
      ]
    ) || 0;


  // ===================================================
  // EXCHANGE RATE
  // ===================================================

  const exchangeRate =
    Number(
      selectedCountry.rate
    ) || 0;


  // ===================================================
  // RECEIVE AMOUNT
  // ===================================================

  const receiveAmount = useMemo(() => {

    if (
      numericAmount <= 0 ||
      exchangeRate <= 0
    ) {

      return 0;

    }

    return (
      numericAmount /
      exchangeRate
    );

  }, [
    numericAmount,
    exchangeRate,
  ]);


  // ===================================================
  // BELOW MINIMUM
  // ===================================================

  const isBelowMinimum =
    numericAmount > 0 &&
    numericAmount < minimumAmount;


  // ===================================================
  // FORMAT NUMBER
  // ===================================================

  const formatAmount = (value) => {

    if (
      value === null ||
      value === undefined ||
      Number(value) === 0
    ) {

      return "0";

    }

    return Number(value).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }
    );

  };


  // ===================================================
  // BACK
  // ===================================================

  const handleBack = () => {

    if (window.history.length > 1) {

      navigate(-1);

    } else {

      navigate("/");

    }

  };


  // ===================================================
  // CONTINUE
  // ===================================================

  const handleContinue = () => {

    // -----------------------------------------------
    // CLEAR OLD MESSAGE
    // -----------------------------------------------

    setValidationMessage("");


    // -----------------------------------------------
    // CHECK AMOUNT
    // -----------------------------------------------

    if (numericAmount <= 0) {

      setValidationMessage(
        t.amountRequired
      );

      return;

    }


    // -----------------------------------------------
    // CHECK MINIMUM
    // -----------------------------------------------

    if (
      numericAmount <
      minimumAmount
    ) {

      setValidationMessage(
        `${t.minimumDeposit} ${formatAmount(
          minimumAmount
        )} ${selectedCountry.currency}.`
      );

      return;

    }


    // -----------------------------------------------
    // CHECK NETWORK
    // -----------------------------------------------

    if (!selectedMethod) {

      setValidationMessage(
        t.networkRequired
      );

      return;

    }


    // -----------------------------------------------
    // CREATE DEPOSIT DATA
    // -----------------------------------------------

    const depositData = {

      type:
        tab === "Buy"
          ? "Deposit"
          : "Withdraw",

      country:
        selectedCountry,

      countryName:
        selectedCountry.name,

      flag:
        selectedCountry.flag,

      currency:
        selectedCountry.currency,

      amount:
        numericAmount,

      minimumAmount:
        minimumAmount,

      rate:
        exchangeRate,

      receiveAmount:
        receiveAmount,

      receiveCurrency:
        "USDT",

      paymentMethod:
        selectedMethod,

      excludeVerification:
        excludeVerification,

    };


    // -----------------------------------------------
    // DEBUG
    // -----------------------------------------------

    console.log(
      "DEPOSIT DATA:",
      depositData
    );


    // -----------------------------------------------
    // PELEKA OTHER COUNTRY CONFIRMED
    // -----------------------------------------------

    navigate(
      "/other-country-confirmed",
      {
        state: {

          deposit: depositData,

          countryName:
            selectedCountry.name,

          flag:
            selectedCountry.flag,

          currency:
            selectedCountry.currency,

          amount:
            numericAmount,

          minimumAmount:
            minimumAmount,

          rate:
            exchangeRate,

          receiveAmount:
            receiveAmount,

          receiveCurrency:
            "USDT",

          paymentMethod:
            selectedMethod,

          excludeVerification:
            excludeVerification,

        },
      }
    );

  };


  // ===================================================
  // RETURN
  // ===================================================

  return (

    <div className="deposit-page">


      {/* =================================================
          HEADER
      ================================================= */}

      <div className="deposit-header">

        <button
          type="button"
          className="back-button"
          onClick={handleBack}
          aria-label={t.back}
        >

          <FaArrowLeft />

        </button>


        <h2>
          {t.depositExpress}
        </h2>

      </div>


      {/* =================================================
          DEPOSIT / WITHDRAW
      ================================================= */}

<div className="buy-sell">

  <button
    type="button"
    className="active"
    onClick={() => {
      setTab("Buy");
      setValidationMessage("");
    }}
  >
    {t.deposit}
  </button>

  <button
    type="button"
    className=""
    onClick={() => {
      navigate("/withdraw");
    }}
  >
    {t.withdraw}
  </button>

</div>

      {/* =================================================
          YOU PAY
      ================================================= */}

      <div className="deposit-card">

        <label>
          {t.youPay}
        </label>


        <div className="pay-row">

          <input
            type="number"
            inputMode="decimal"
            min="0"
            placeholder="0"
            value={amount}
            onChange={(e) => {

              const value =
                e.target.value;


              // Usiruhusu negative
              if (
                Number(value) < 0
              ) {

                return;

              }


              setAmount(value);


              // Ondoa validation user akianza kuandika
              if (
                validationMessage
              ) {

                setValidationMessage("");

              }

            }}
          />


          {/* COUNTRY BUTTON */}

          <button
            type="button"
            className="currency-btn"
            onClick={() => {

              setValidationMessage("");

              setShowCountry(true);

            }}
          >

            <span className="flag">

              {selectedCountry.flag}

            </span>


            <span className="currency">

              {selectedCountry.currency}

            </span>


            <FaChevronDown />

          </button>

        </div>


        {/* =================================================
            MINIMUM
        ================================================= */}

        <div className="minimum-amount">

          {t.minimumDeposit}{" "}

          <strong>

            {formatAmount(
              minimumAmount
            )}{" "}

            {selectedCountry.currency}

          </strong>

        </div>


        {/* =================================================
            AMOUNT ERROR
        ================================================= */}

        {isBelowMinimum && (

          <div className="amount-error">

            {t.minimumAmount}{" "}

            <strong>

              {formatAmount(
                minimumAmount
              )}{" "}

              {selectedCountry.currency}

            </strong>

          </div>

        )}

      </div>


      {/* =================================================
          EXCHANGE ICON
      ================================================= */}

      <div className="exchange-icon">

        <FaExchangeAlt />

      </div>


      {/* =================================================
          YOU RECEIVE
      ================================================= */}

      <div className="deposit-card">

        <label>
          {t.youReceive}
        </label>


        <div className="pay-row">

          <input
            type="text"
            value={
              receiveAmount > 0
                ? receiveAmount.toFixed(2)
                : "0"
            }
            readOnly
          />


          <button
            type="button"
            className="currency-btn usdt"
          >

            <span className="flag">
              💲
            </span>


            <span className="currency">
              USDT
            </span>

          </button>

        </div>

      </div>


      {/* =================================================
          EXCHANGE RATE
      ================================================= */}

      <div className="rate-box">

        <span>
          {t.exchangeRate}
        </span>


        <span>

          1 USDT ≈{" "}

          {formatAmount(
            exchangeRate
          )}{" "}

          {selectedCountry.currency}

        </span>

      </div>


      {/* =================================================
          VERIFICATION
      ================================================= */}

      <div className="verify-box">

        <label className="checkbox">

          <input
            type="checkbox"
            checked={
              excludeVerification
            }
            onChange={(e) =>
              setExcludeVerification(
                e.target.checked
              )
            }
          />


          <span>

            {t.excludeVerification}

          </span>

        </label>

      </div>


      {/* =================================================
          PAYMENT METHOD
      ================================================= */}

      <div className="payment-card">

        <label>
          {t.paymentMethod}
        </label>


        <button
          type="button"
          className="payment-btn"
          onClick={() => {

            setValidationMessage("");

            setShowPaymentMethods(true);

          }}
        >

          <span>

            {selectedMethod ||
              t.selectPayment}

          </span>


          <FaChevronDown />

        </button>


        {/* =================================================
            VALIDATION MESSAGE
        ================================================= */}

        {validationMessage && (

          <div className="payment-validation-error">

            {validationMessage}

          </div>

        )}

      </div>


      {/* =================================================
          PAYMENT METHOD MODAL
      ================================================= */}

      {showPaymentMethods && (

        <div
          className="payment-overlay"
          onClick={() =>
            setShowPaymentMethods(false)
          }
        >

          <div
            className="payment-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >


            {/* =========================================
                HEADER
            ========================================== */}

            <div className="payment-modal-header">

              <h3>
                {t.selectPaymentTitle}
              </h3>


              <button
                type="button"
                className="payment-close"
                onClick={() =>
                  setShowPaymentMethods(false)
                }
                aria-label={t.close}
              >

                ×

              </button>

            </div>


            {/* =========================================
                COUNTRY
            ========================================== */}

            <div className="payment-country">

              <span className="payment-country-flag">

                {selectedCountry.flag}

              </span>


              <span>

                {selectedCountry.name}

              </span>

            </div>


            {/* =========================================
                NETWORKS
            ========================================== */}

            <div className="network-list">

              {availableNetworks.map(
                (network) => (

                  <button
                    type="button"
                    key={network}
                    className={
                      selectedMethod === network
                        ? "network-item selected"
                        : "network-item"
                    }
                    onClick={() =>
                      handlePaymentMethod(
                        network
                      )
                    }
                  >

                    <span>
                      {network}
                    </span>


                    {selectedMethod === network && (

                      <span className="network-check">

                        ✓

                      </span>

                    )}

                  </button>

                )
              )}


              {/* =======================================
                  NO NETWORK
              ======================================== */}

              {availableNetworks.length === 0 && (

                <div className="no-network">

                  {t.noPayment} {t.for}{" "}

                  <strong>
                    {selectedCountry.name}
                  </strong>.

                </div>

              )}

            </div>

          </div>

        </div>

      )}


      {/* =================================================
          CONTINUE
      ================================================= */}

      <button
        type="button"
        className="continue-btn"
        onClick={handleContinue}
      >

        {t.continue}

      </button>


      {/* =================================================
          COUNTRY SELECTOR
      ================================================= */}

      {showCountry && (

        <CountrySelector

          selected={
            selectedCountry
          }

          onSelect={
            handleCountrySelect
          }

          onClose={() =>
            setShowCountry(false)
          }

        />

      )}

    </div>

  );

}
